import React, { Component } from 'react';
import PropTypes from 'prop-types';

import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import MailMergeDropdown from '../components/mailmerge/MailMergeDropdown';

function htmlToEditorState(html){
    let editorState = EditorState.createEmpty();
    const contentBlock = htmlToDraft(html);
    if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        editorState = EditorState.createWithContent(contentState);
    }
    return editorState;
}

function editorStateToHtml(editorState) {
    return draftToHtml(convertToRaw(editorState.getCurrentContent()));
}

class WysiwygEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editorState: null
        }
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
    }
    onEditorStateChange(editorState) {
        const {onChange} = this.props;
        const html = editorStateToHtml(editorState);
        onChange(html);
        this.setState({editorState})
    }
    render() {
        const {editorState} = this.state;
        const {fields, template} = this.props;
        return (
            <Editor
            wrapperClassName="wsywig-wrapper"
            editorClassName="wsywig-editor"
            onEditorStateChange={this.onEditorStateChange}
            toolbarCustomButtons={[<MailMergeDropdown fields={fields} />]}
            editorState={editorState || htmlToEditorState(template || '')}
          />
        );
    }
}

WysiwygEditor.propTypes = {
    onChange: PropTypes.func.isRequired,
    fields: PropTypes.array,
    template: PropTypes.string,
};

export default WysiwygEditor;